import { render, staticRenderFns } from "./auth-cover-signup.vue?vue&type=template&id=4ad8f85f&"
import script from "./auth-cover-signup.vue?vue&type=script&lang=js&"
export * from "./auth-cover-signup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports